/*
 * 接口统一集成模块 — 售后大屏（as-web）
 */
import * as auth from "./moudules/auth";
import * as workorders from "./moudules/workorders";
import * as common from "./moudules/common";
import * as user from "./moudules/user";
import * as project from "./moudules/project";
import * as robot from "./moudules/robot";
import * as remotor from "./moudules/remotor";
import * as version from "./moudules/version";

export default {
  auth,
  workorders,
  common,
  user,
  project,
  robot,
  remotor,
  version,
};
